import Part from "../../part";

export default class NonAlcoholic extends Part {

  constructor(section) {
    super(section);

  }

  get options() {
    return {

      'simple': {
        price: 3,
        description: `Canned Coke products Zingerman’s brewed Coffee`,
      },
      'medium': {
        price: 6,
        description: `Brewed coffee, hot tea, bottles of Spindrift waters, and Faygo sodas`,
      },
      'deluxe': {
        price: 10,
        description: `A wide array of beverages including lemonade, iced tea, coffee, Spindrift waters, and  a custom mocktail.`,
      },
      'none': {
        price: 0,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/beverages/nonalcoholic.js